import { render } from "./Message.vue?vue&type=template&id=79d3f130&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "@/styles/header.css?vue&type=style&index=0&id=79d3f130&scoped=true&lang=css&external"
import "@/styles/common.css?vue&type=style&index=1&id=79d3f130&scoped=true&lang=css&external"
import "@/styles/subcommon.css?vue&type=style&index=2&id=79d3f130&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../../../../../../../private/tmp/codex-user-modern-deps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d3f130"]])

export default __exports__